import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageLayout from '@/components/layout/PageLayout';
import { PrimaryButton } from '@/components/ui/buttons/PrimaryButton';
import { IconScout } from '@/components/ui/images/IconScout';
import { Card } from '@/components/ui/cards/Card';
import { Text } from '@/components/ui/text/Text';
import { useUI } from '@/hooks/ui';
import { PermissionGuard } from '@/components/layout';
import { colors } from '@/assets/styles/colors';

/**
 * Page for manually registering attendance
 * Opens a side panel with the form to register attendance manually
 */
const ImputarAsistencia: React.FC = () => {
  const { t: translate } = useTranslation();
  const { openSidePanel } = useUI();

  const handleOpenForm = useCallback(() => {
    openSidePanel({
      title: translate('attendance:manual.title'),
      component: 'ManualAttendanceForm',
      props: {},
    });
  }, [openSidePanel, translate]);

  // Auto-open side panel when page loads (for menu navigation)
  useEffect(() => {
    handleOpenForm();
  }, [handleOpenForm]);

  return (
    <PageLayout>
      <div className="flex flex-col gap-6" data-testid="imputar-asistencia-page">
        <Card elevation={1} className="p-6">
          <div className="flex flex-col gap-6 items-center text-center max-w-2xl mx-auto py-8">
            <div className="w-16 h-16 rounded-full bg-primary-50 flex items-center justify-center">
              <IconScout name="calendarAlt" size={32} color={colors.primary.main} />
            </div>
            
            <div className="flex flex-col gap-2">
              <Text variant="header-5">
                {translate('attendance:manual.pageTitle')}
              </Text>
              <Text variant="body-regular" color={colors.grays.neutral66}>
                {translate('attendance:manual.pageDescription')}
              </Text>
            </div>

            <PermissionGuard action="create">
              <PrimaryButton
                onClick={handleOpenForm}
                iconLeft={<IconScout name="plus" />}
                data-testid="open-manual-attendance-button"
              >
                {translate('attendance:manual.openButton')}
              </PrimaryButton>
            </PermissionGuard>
          </div>
        </Card>
      </div>
    </PageLayout>
  );
};

export default ImputarAsistencia;
